import type { FC, PropsWithChildren } from 'react';
import {
    SkeletonAvatar,
    SkeletonLine,
    Spinner,
    StripeProductInfo,
} from '@george-labs.com/design-system';

import { useGlobalColorVariants } from '@shared/core-ui-layout';
import { FocusPage } from '@shared/focus-page-ui';

import styles from '../MainLayout.module.scss';

interface Props {
    'data-cy'?: string;
}

export const ProductFocusPageSkeleton: FC<PropsWithChildren<Props>> = ({
    children = <Spinner center />,
    'data-cy': dataCy = 'product-layout-skeleton-loader',
}) => {
    const { color } = useGlobalColorVariants();

    return (
        <div data-cy={dataCy} className={styles['products-main-layout']}>
            <FocusPage
                color={color}
                title={
                    <SkeletonLine level={2} animated percentageWidth={50} className="m-auto pt-0" />
                }
                onCloseClick={() => window.history.back()}
                left={
                    <StripeProductInfo
                        avatar={<SkeletonAvatar animated size={SkeletonAvatar.SIZE.SIZE_48} />}
                        alias={
                            <div className="vw-100 mw-100">
                                <SkeletonLine level={5} animated percentageWidth={100} />
                            </div>
                        }
                        amount={
                            <SkeletonLine
                                level={5}
                                animated
                                percentageWidth={50}
                                className="pt-0"
                            />
                        }
                    />
                }
            >
                {children}
            </FocusPage>
        </div>
    );
};
